@if (initialNavigationPending()) {
  <div class="app-boot-loader" role="status">
    <img class="app-boot-loader__mark" ngSrc="/favicon.png" alt="" width="64" height="64" priority />
    <span class="dk-spinner__label">Loading Declunk…</span>
  </div>
}
<router-outlet />
<toast-container />
